const BaseModule = require('../../90_utils/base/BaseModule');

class ImpactFooter extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$background = this.$el.find('.footer-bg');
		this.$headline = this.$el.find('.quote');
		this.$blurb = this.$el.find('.blurb');
	}

	// basemodule methods

	_domReady(){

		// console.log(this.$headline);
	}

	_addListeners(){

		// this.$headline.on('show', $.proxy(this._showHeadline, this));
	}

	_removeListeners(){ }

	//

	_showHeadline(){


	}

	//

	_show(){

		TweenMax.set([this.$background, this.$headline, this.$blurb], { opacity: 0 });

		TweenMax.to(this.$background, 1.6, {
			opacity: 1,
			ease: 'longFade'
		});

		this.$headline.one('show', ()=>{
			TweenMax.fromTo(this.$headline, 0.6, {opacity:0, y:30}, {opacity:1, y:0, ease:'longFade'});
			TweenMax.fromTo(this.$blurb, 0.6, {opacity:0, y:30}, {opacity:1, y:0, delay:0.5, ease:'longFade'});
		});
	}

	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		if(window.SETTINGS.breakpoint.minWidth('screen-medium')){
			TweenMax.killTweensOf([this.$background, this.$headline, this.$blurb]);
			TweenMax.set([this.$background, this.$headline, this.$blurb], {opacity:1, y:0});
		}
		else {
			TweenMax.killTweensOf([this.$background, this.$headline, this.$blurb]);
			TweenMax.set([this.$background, this.$headline, this.$blurb], {clearProps:'opacity, y'});
		}
	}
}

module.exports = ImpactFooter;
